import { ComponentProps, FC, useCallback, useEffect } from "react"
import { talukaAddApi } from "src/domain/api/taluka/talukaAddApi"
import { Taluka } from "../../../../domain/entities/taluka"
import { useAuth, useDistrictListApi } from "../../../../domain/hooks"
import { FormikOnSubmit } from "../../../../utils/types"
import { ITalukaAddFormFields } from "./ITalukaAddFormFields"
import { TalukaAddDrawerFormView } from "./TalukaAddDrawerFormView"

interface Props
	extends Omit<
		ComponentProps<typeof TalukaAddDrawerFormView>,
		"handleSubmit" | "districtList"
	> {
	onSuccess: (taluka: Taluka) => void
}

export const TalukaAddDrawerFormController: FC<Props> = ({ onSuccess, ...rest }) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<ITalukaAddFormFields>>(
		async (values, { setErrors }) => {
			try {
				const taluka = await talukaAddApi(values, token)
				onSuccess(taluka)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({
					name: {
						en: message,
					},
				})
			}
		},
		[onSuccess, rest, token],
	)

	const { fetchDistrictList, districtList } = useDistrictListApi()

	useEffect(() => {
		fetchDistrictList()
	}, [fetchDistrictList])

	return (
		<TalukaAddDrawerFormView
			handleSubmit={handleSubmit}
			districtList={districtList}
			{...rest}
		/>
	)
}
